/**
 *
 * GSTR-9C New Save Constants
 *
 */

// Loader Constants
export const LOADER_STATUS = 'boilerplate/Gstr9CNew/LOADER_STATUS';

// Table Data Constants
export const SET_SAVE_TABLE_DATA = 'boilerplate/Gstr9CNew/SET_SAVE_TABLE_DATA';
export const SET_FETCH_TABLE_DATA = 'boilerplate/Gstr9CNew/SET_FETCH_TABLE_DATA';

// Selection Management Constants - Save Tab
export const SET_SELECTED_SAVE = 'boilerplate/Gstr9CNew/SET_SELECTED_SAVE';
export const SET_SELECTED_ROW_SAVE = 'boilerplate/Gstr9CNew/SET_SELECTED_ROW_SAVE';

// Selection Management Constants - Fetch Tab
export const SET_SELECTED_FETCH = 'boilerplate/Gstr9CNew/SET_SELECTED_FETCH';
export const SET_SELECTED_ROW_FETCH = 'boilerplate/Gstr9CNew/SET_SELECTED_ROW_FETCH';